import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAiMagic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#1F5ACE"
      fillRule="evenodd"
      d="M13.82 3.6c0-.012-.023-.012-.024 0a3.425 3.425 0 0 1-3.01 3.011c-.013.001-.013.023 0 .025a3.425 3.425 0 0 1 3.01 3.01c.001.013.024.013.025 0a3.425 3.425 0 0 1 3.01-3.01c.013-.002.013-.024 0-.025a3.425 3.425 0 0 1-3.01-3.011Z"
      clipRule="evenodd"
    />
    <path
      fill="#256CF7"
      fillRule="evenodd"
      d="M7.059 5.114c-.001-.012-.022-.012-.023 0A5.275 5.275 0 0 1 2.32 9.83c-.012.001-.012.022 0 .023a5.275 5.275 0 0 1 4.715 4.715c.001.012.022.012.023 0a5.275 5.275 0 0 1 4.715-4.715c.012-.001.012-.022 0-.023a5.275 5.275 0 0 1-4.715-4.715Z"
      clipRule="evenodd"
    />
    <path
      fill="#729FF9"
      fillRule="evenodd"
      d="M12.673 11.411c-.002-.016-.034-.016-.037 0a2.896 2.896 0 0 1-2.474 2.474c-.016.003-.016.035 0 .037a2.896 2.896 0 0 1 2.474 2.475c.003.016.035.016.037 0a2.896 2.896 0 0 1 2.475-2.475c.016-.002.016-.034 0-.037a2.896 2.896 0 0 1-2.475-2.474"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAiMagic;
